import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { FcCalendar } from "react-icons/fc";
import { getLastEmission } from "@store/action/planning/EmissionAction";
import { Form } from "reactstrap";
import { useForm } from "react-hook-form";
import FollowUs from "../../FollowUs";

const FilterBlog = ({ store, t, setCurrentPage, dispatch, path }) => {
  const [search, setSearch] = useState("");
  const lang = localStorage.getItem("lang") || "en";
  const lang1 = lang.substring(1, lang.length - 1) || "en";

  const { handleSubmit } = useForm();
  const history = useHistory();
  const onSubmit = () => {
    setCurrentPage(1);
    history.push(`/${path}?search=${search}`);
  };
  const renderRecentPostTopics = () => {
    if (store?.Last.length) {
      return store?.Last.map((item, i) => {
        return (
          <li
            key={i}
            style={{
              paddingBottom: "0",
              marginBottom: "15px",
              borderBottom: "0",
            }}
          >
            <div className="suggest-img">
              <Link to={`/emission/${item.id}`}>
                <img
                  width="70px"
                  height="60px"
                  src={item.picture}
                  alt="topic"
                />
              </Link>
            </div>
            <div className="suggest-content">
              <div className="suggest-title">
                <div className="mail-body">
                  <div className="mail-message">
                    <h4 style={{ width: "200px" }} className="text-truncate">
                      {item?.name}
                    </h4>
                  </div>
                </div>
              </div>

              <div className="suggest-meta mx-1">
                <div className="suggest-date">
                  <FcCalendar />
                  <p>
                    {new Date(item.created_at).toLocaleString(`${lang1}-US`, {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </p>
                </div>
                <div className="suggest-comment">
                  <i className="fa fa-comments"></i>
                  <p>{item.nbr_comments}</p>
                </div>
              </div>
            </div>
          </li>
        );
      });
    }
  };
  useEffect(() => {
    dispatch(getLastEmission());
  }, []);

  return (
    <div className="col-lg-3">
      <div className="row">
        <div className="col-lg-12">
          <Form className="blog-src" onSubmit={handleSubmit(onSubmit)}>
            <input
              onChange={(e) => setSearch(e.target.value)}
              type="text"
              placeholder={t("Search...")}
            />
            <button type="submit">
              <i className="fa fa-search"></i>
            </button>
          </Form>
        </div>
        <div className="col-md-7 col-lg-12">
          <div className="blog-filter">
            <h3>{t("Recent post")}</h3>
            <ul className="blog-suggest">{renderRecentPostTopics()}</ul>
          </div>
        </div>
        <FollowUs />
      </div>
    </div>
  );
};

export default FilterBlog;
